import { Suspense, lazy } from "react";

import Loading from "components/Loading";

const CancelRequestPage = lazy(() => import("pages/CancelRequest/pc/CancelRequestPresenter"));

const CancelRequestContainer = () => {
  return (
    <Suspense fallback={<Loading />}>
      <CancelRequestPage />
    </Suspense>
  );
};

export default CancelRequestContainer;
